.media-library-page {
	padding: 0 !important;
}
